export enum HttpStatus {
  OK = 200,
  Created = 201,
  NoContent = 204,
  BadRequest = 400,
  Unauthorized = 401,
  ExpiredSubscribe = 402,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  Gone = 410,
  LargeRequest = 413,
  UnprocessableEntity = 422,
  ManyRequests = 429,
  InternalServerError = 500,
}

export type MapBounds = {
  maxLat?: number;
  maxLng?: number;
  minLat?: number;
  minLng?: number;
};

export type MapCenter = {
  lat: number;
  lng: number;
};

export type MarkerType = {
  id: number;
  zone_id: number;
  key: string;
  location: google.maps.LatLngLiteral;
  type: MarkerColor;
  is_paid?: boolean;
};

export type ErrorsType = { [key: string]: string[] };

export enum ModalType {
  USER_DELETE = 'USER_DELETE',
  SENSOR_DELETE = 'SENSOR_DELETE',
  ZONE_DELETE = 'ZONE_DELETE',
  OBJECT_DELETE = 'OBJECT_DELETE',
  QUESTIONNAIRE_DELETE = 'QUESTIONNAIRE_DELETE',
  GATEWAY_DELETE = 'GATEWAY_DELETE',
  GATEWAY_CONFIG = 'GATEWAY_CONFIG',
  PAGE_LEAVE = 'PAGE_LEAVE',
}

enum HttpExceptionType {
  REFRESH_TOKEN_EXPIRED = 'REFRESH_TOKEN_EXPIRED',
  REFRESH_TOKEN_VERIFY = 'REFRESH_TOKEN_VERIFY',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  TOKEN_MALFORMED = 'TOKEN_MALFORMED',
  TOKEN_NOT_PROVIDED = 'TOKEN_NOT_PROVIDED',
  TOKEN_VERIFY = 'TOKEN_VERIFY',
}

export type ErrorResponseType = {
  code: HttpExceptionType;
  errors: ErrorsType;
  exception?: string;
  message: string;
  detail?: string;
  status: number;
};

export type MetaData = {
  total: number;
  skip: number;
  limit: number;
  page: number;
  pages: number;
};

export enum SortValues {
  ASC = 'asc',
  DESC = 'desc',
}

export enum Role {
  ADMIN = 'admin',
  USER = 'user',
}

export enum SensorTrends {
  UP = 'up',
  DOWN = 'down',
}

export enum SensorStatus {
  ONLINE = 'online',
  OFFLINE = 'offline',
}

export enum MarkerColor {
  BLUE = 'blue',
  YELLOW = 'yellow',
  RED = 'red',
  GRAY = 'gray',
}

export type ZoneAiAnalysis = {
  id: number;
  zone_id: number;
  status: string;
  analysis_text: string;
  created_at: string;
};

export enum SensorBattery {
  LOW = 'low',
  HIGH = 'high',
}

export type ObjectType = {
  name: string;
  file_id: string;
  original_filename: null;
  user_id: number;
  id: number;
  is_deleted: boolean;
  deleted_at: string | null;
  created_at: string;
  updated_at: string;
  zones: ObjectZoneType[];
  sensors: ObjectSensorType[];
};

export type ObjectZoneType = Omit<
  ObjectType,
  'file_id' | 'original_filename' | 'zones'
> & {
  object_id: number;
  photo_file_id?: string | null;
  photo_original_filename?: string | null;
  plant_type?: string | null;
  plant_name?: string | null;
  soil_type?: string | null;
  sensors: ObjectSensorType[];
};

export type ObjectSensorType = {
  sensor_type: string;
  sensor_eui: string;
  plant_type: string;
  plant_name: string;
  soil_type: string | null;
  zone_id: number;
  user_id: number;
  id: number;
  active: boolean;
  is_deleted: boolean;
  deleted_at: string | null;
  created_at: string;
  updated_at: string;
  is_paid: boolean;
  latest_metrics?: ObjectSensorMetricsType[];
};

export type ObjectSensorMetricsType = {
  id: number;
  sensor_id: number;
  device_eui: 'string';
  points: ObjectSensorMetricPointsType[];
  online_status: number;
  battery_status: number;
  be_quota: number;
  latitude: number;
  longitude: number;
  time: string;
  created_at: string;
};

export type ObjectSensorMetricPointsType = {
  id: number;
  measurement_value: number;
  measurement_id: string;
  measurement_name: string;
  time: string;
  trend: string;
};
